// src/controllers/context/LeadContext.js
import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';

const LeadContext = createContext();

export const useLeadContext = () => useContext(LeadContext);

export const LeadProvider = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState({ title: '', source: '', type: '' });

  const openPopup = useCallback((title, source, type, extraData = {}) => {
    setPopupData({ title, source, type, ...extraData });
    setIsPopupOpen(true);
  }, []);

  const closePopup = useCallback(() => {
    setIsPopupOpen(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      isPopupOpen,
      popupData,
      openPopup,
      closePopup,
    }),
    [isPopupOpen, popupData, openPopup, closePopup]
  );

  return (
    <LeadContext.Provider value={contextValue}>
      {children}
    </LeadContext.Provider>
  );
};
